module.exports = __webpack_public_path__ + "img/p-zhongtoubao.5319f505.png";